module.exports = __webpack_public_path__ + "img/11.21f74285.jpg";